import Rest from '@services/Rest';

export default class PermissionsService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/permissions';

  /**
   * Traz todas as Roles (adm_roles) em grupos com os usuários que estão associados a elas
   */
  getGroupUsers(only = false) {
    const route = '/groups-users';
    if (only) {
      return this.get(route + '?only_roles=true');
    }
    return this.get(route);
  }

  /**
   * Traz a lista das permissões (screen_action_permissions)
   */
  getAllPermissions() {
    return this.get(`/all-permissions`);
  }

  /**
   * Traz as informações do usuário (id, Nome, e-mail, data de registro, adm_role)
   * e todas as permissões, priorizando as que ele possui acesso
   * @param {String|Number} userId
   */
  getUserPermissions(userId) {
    if (!userId) {
      return Promise.reject(new Error('userId is required'));
    }
    return this.get(
      `/user-permissions/${userId}`
    );
  }

  /**
   * Traz as informações do tabela adm_roles
   */
  getAdmRoles() {
    return this.get(
      `/adm-roles`
    );
  }
}
